import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../shared/http-general.service';
import { OutpatientParms} from '../../shared';
import { CONFIG } from '../../shared/config';

let clinicServiceUrl = CONFIG.baseUrls.clinicService;

@Injectable()
export class ClinicServiceService {

    constructor(private httpGeneralService: HttpGeneralService) { }

    getAllServices(pageSize: number, offset: number) {
        return this.httpGeneralService.getWith(`${clinicServiceUrl}/allServices/${pageSize}/${offset}`);
    }

    getSpecialServices(outpatientParms: OutpatientParms, pageSize: number, offset: number) {
      return this.httpGeneralService.search(outpatientParms,`${clinicServiceUrl}/SpecialServices/${pageSize}/${offset}`)
      //return this.httpGeneralService.getWith(OutpatientParms,`${clinicServiceUrl}/SpecialServices/${pageSize}/${offset}`);
    }

    getClinicService(serial: number) {
        return this.httpGeneralService.get(serial, clinicServiceUrl);
    }

    addClinicService(clinicService: ClinicService) {
        return this.httpGeneralService.add(clinicService, clinicServiceUrl);
    }

    addClinicServices(clinicServices: ClinicService[]) {
        return this.httpGeneralService.addCollection(clinicServices, `${clinicServiceUrl}/addClinicServices`);
    }
}


export interface ClinicService {
    serial: number;
    specialId?: number;
    docId?: number;
    docCatId?: number; 
    serviceId: number;
    noOfSlot: number;
    isDefault: boolean,
    isExamService: boolean;
    isActive: boolean;
    isNew?: boolean;
    isValid?: boolean;
    hasFollowUp: boolean;
    followUpPeriod: number;
    noOfFollowUp: number;
    include?: boolean;
    specialityNameEn?: string;
    specialityNameAr?: string;
    serviceNameEn?: string;
    serviceNameAr?: string;
    dataStatus?: number;
    customCode?:string;
    customServiceCode ?:string;
} 
export enum State {
    Added = 1,
    Modified = 2,
    Deleted = 3,
    Unchanged = 4,
 }
